export default __webpack_public_path__ + "static/media/(17).3aecb9b4.jpg";